var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPaperclip(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.5002 5.83241L7.08357 11.2491C6.75205 11.5806 6.56581 12.0302 6.56581 12.4991C6.56581 12.9679 6.75205 13.4176 7.08357 13.7491C7.41509 14.0806 7.86473 14.2668 8.33357 14.2668C8.80241 14.2668 9.25205 14.0806 9.58357 13.7491L15.0002 8.33241C15.6633 7.66937 16.0358 6.77009 16.0358 5.83241C16.0358 4.89473 15.6633 3.99545 15.0002 3.33241C14.3372 2.66937 13.4379 2.29688 12.5002 2.29688C11.5626 2.29687 10.6633 2.66937 10.0002 3.33241L4.58357 8.74908C3.58901 9.74364 3.03027 11.0926 3.03027 12.4991C3.03027 13.9056 3.58901 15.2545 4.58357 16.2491C5.57814 17.2436 6.92705 17.8024 8.33357 17.8024C9.7401 17.8024 11.089 17.2436 12.0836 16.2491L17.5002 10.8324",
    stroke: "currentColor",
    strokeWidth: 1.6,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPaperclip);
export default __webpack_public_path__ + "static/media/paperclip.04e29047.svg";
export { ForwardRef as ReactComponent };